import React from "react";
import { Helmet } from "react-helmet";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>{"Contact Us"}</title>
        <meta name="title" content={`${"Contact Us"}`} />
        <meta name="author" content="Eykam Wellness" />
        <meta
          property="og:description"
          content="India’s first Vitamin D chocolate from Eykam Wellness. Healthy. Delicious. Effective."
        />
        <link
          rel="canonical"
          href={`https://sunkisseddelight.com/contact-us`}
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          href={`https://sunkisseddelight.com/contact-us`}
        />
        <meta property="og:title" content={`${"Contact Us"}`} />
        <meta
          property="og:description"
          content="India’s first Vitamin D chocolate from Eykam Wellness. Healthy. Delicious. Effective."
        />
      </Helmet>{" "}
      <main
        id="qodef-page-content"
        className="qodef-grid qodef-layout--template "
      >
        <div className="qodef-grid-inner clear">
          <div className="qodef-grid-item qodef-page-content-section qodef-col--12">
            <div
              data-elementor-type="wp-page"
              data-elementor-id={4445}
              className="elementor elementor-4445"
              data-elementor-settings="[]"
            >
              <div className="elementor-inner">
                <div className="elementor-section-wrap">
                  <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-d2122a6 elementor-section-full_width elementor-section-height-min-height elementor-section-height-default elementor-section-items-middle qodef-elementor-content-no"
                    data-id="d2122a6"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-row">
                        <div
                          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-cf1bc04"
                          data-id="cf1bc04"
                          data-element_type="column"
                        >
                          <div className="elementor-column-wrap">
                            <div className="elementor-widget-wrap"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>

            <div id="qodef-page-inner" className="qodef-content-full-width">
              <main
                id="qodef-page-content"
                className="qodef-grid qodef-layout--template "
              >
                <div className="qodef-grid-inner clear">
                  <div className="qodef-grid-item qodef-page-content-section qodef-col--12">
                    <div
                      data-elementor-type="wp-page"
                      data-elementor-id={5042}
                      className="elementor elementor-5042"
                      data-elementor-settings="[]"
                    >
                      <div className="elementor-inner">
                        <div className="elementor-section-wrap">
                          <section
                            className="elementor-section elementor-top-section elementor-element elementor-element-84e8706 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                            data-id="84e8706"
                            data-element_type="section"
                          >
                            <div className="elementor-container elementor-column-gap-default">
                              <div className="elementor-row">
                                <div
                                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9d66c2a"
                                  data-id="9d66c2a"
                                  data-element_type="column"
                                >
                                  <div className="elementor-column-wrap elementor-element-populated">
                                    <div className="elementor-widget-wrap">
                                      <div
                                        className="elementor-element elementor-element-2fa3ec6 elementor-widget__width-initial elementor-widget elementor-widget-swissdelight_core_section_title"
                                        data-id="2fa3ec6"
                                        data-element_type="widget"
                                        data-widget_type="swissdelight_core_section_title.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--center  qodef-appear-animation--enabled">
                                            <h2 className="qodef-m-title">
                                              We’re Here to Help
                                            </h2>
                                            <p
                                              className="qodef-m-text"
                                              style={{ margin: 15 }}
                                            >
                                              Whether you have a question, need
                                              help placing an order, or want to
                                              know more about our products just
                                              reach out. We’d love to hear from
                                              you.
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="elementor-element elementor-element-55c567d elementor-widget elementor-widget-wp-widget-swissdelight_core_contact_form_7"
                                        data-id="55c567d"
                                        data-element_type="widget"
                                        data-widget_type="wp-widget-swissdelight_core_contact_form_7.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="qodef-contact-form-7">
                                            <div
                                              className="wpcf7 no-js"
                                              id="wpcf7-f2929-p5042-o1"
                                              lang="en-US"
                                              dir="ltr"
                                            >
                                              <div className="screen-reader-response">
                                                <p
                                                  role="status"
                                                  aria-live="polite"
                                                  aria-atomic="true"
                                                />{" "}
                                                <ul />
                                              </div>
                                              <form
                                                action="https://formsubmit.co/eykamwellness@gmail.com"
                                                method="post"
                                                noValidate="validate"
                                                className="wpcf7-form init demo"
                                                aria-label="Contact form"
                                                data-status="init"
                                              >
                                                <div
                                                  style={{ display: "none" }}
                                                ></div>
                                                <div className="qodef-about-us">
                                                  <span
                                                    className="wpcf7-form-control-wrap"
                                                    data-name="name"
                                                  >
                                                    <input
                                                      size={40}
                                                      maxLength={80}
                                                      className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                      aria-required="true"
                                                      aria-invalid="false"
                                                      placeholder="Your Name"
                                                      defaultValue=""
                                                      type="text"
                                                      name="name"
                                                    />
                                                  </span>
                                                  <span
                                                    className="wpcf7-form-control-wrap"
                                                    data-name="phone"
                                                  >
                                                    <input
                                                      size={40}
                                                      maxLength={80}
                                                      className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                      aria-required="true"
                                                      aria-invalid="false"
                                                      placeholder="Your Phone Number"
                                                      defaultValue=""
                                                      type="number"
                                                      name="phone"
                                                    />
                                                  </span>
                                                  <span
                                                    className="wpcf7-form-control-wrap"
                                                    data-name="email"
                                                  >
                                                    <input
                                                      size={40}
                                                      maxLength={80}
                                                      className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email"
                                                      aria-required="true"
                                                      aria-invalid="false"
                                                      placeholder="Your Email"
                                                      defaultValue=""
                                                      type="email"
                                                      name="email"
                                                    />
                                                  </span>
                                                  <span
                                                    className="wpcf7-form-control-wrap"
                                                    data-name="message"
                                                  >
                                                    <textarea
                                                      cols={40}
                                                      rows={7}
                                                      maxLength={400}
                                                      className="wpcf7-form-control wpcf7-textarea"
                                                      aria-invalid="false"
                                                      placeholder="Your Message"
                                                      name="message"
                                                      defaultValue={""}
                                                    />
                                                  </span>
                                                  <input
                                                    type="hidden"
                                                    name="_captcha"
                                                    value="false"
                                                  ></input>
                                                  <input
                                                    type="hidden"
                                                    name="_next"
                                                    value="https://sunkisseddelight.com"
                                                  ></input>
                                                  <input
                                                    type="hidden"
                                                    name="_template"
                                                    value="table"
                                                  ></input>
                                                  <button
                                                    className="wpcf7-form-control wpcf7-submit qodef-layout--outlined qodef-button qodef-size--normal qodef-layout--filled qodef-m"
                                                    type="submit"
                                                  >
                                                    <span className="qodef-m-border--top-left" />
                                                    <span className="qodef-m-border--bottom-right" />
                                                    <span className="qodef-m-text">
                                                      SEND
                                                    </span>
                                                  </button>
                                                </div>
                                                <div
                                                  className="wpcf7-response-output"
                                                  aria-hidden="true"
                                                />
                                              </form>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
            {/* close #qodef-page-inner div from header.php */}
          </div>
        </div>
      </main>
    </>
  );
};

export default Contact;
